// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"b3-z","subtitle":"c3-z","wrapper":"d3-z","leftArrow":"e3-z","rightArrow":"f3-z"};